module.exports = __webpack_public_path__ + "img/WorriedFace.04070ab4.svg";